
import { SelectVM, UserVM } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'
import { getInsurances } from '@/components/insurances/insurance.service'
import {
  getUserInsurances,
  getGenders
} from '@/components/doctors/doctors.service'
import moment from 'moment'

@Component({
  name: 'InsuranceForm',
  components: {
    Multiselect
  }
})
export default class InsuranceForm extends Vue {
  @Prop() form: UserVM
  @Prop() editMode: boolean

  public insuranceList: SelectVM[] = []
  public selectedInsurances: SelectVM[] = []
  public selectedGender: string | null = null
  public genderList: SelectVM[] = [
    { value: null, label: 'Select a gender', _isDisabled: false }
  ]
  public formatted = ''
  public userInsurances = ''
  public confirmation = ''
  @Watch('selectedInsurances', { deep: true })
  onSelectedInsurances() {
    this.syncInsurances()
  }

  public syncInsurances() {
    this.form.insurances = [
      ...new Set(
        (this.selectedInsurances || [])
          .map(i => String(i.value ?? '').trim())
          .filter(Boolean)
      )
    ].join(',')
  }

  @Watch('selectedGender')
  onSelectedGender(newVal) {
    this.form.sex = this.genderList.find(
      c => c.value == this.selectedGender
    )?.label
  }

  public async created() {
    this.form.role = 'Insurance'

    await Promise.all([this.fetchInsurances(), this.fetchGenders()])

    if (this.editMode) {
      this.setGender()
      this.setDateOfBirth()
      this.confirmation = this.form.email1
      await Promise.all([this.setInsurances()])
    }
  }

  public setDateOfBirth() {
    this.formatted = moment(this.form.dob).format('MM/DD/YYYY')
  }
  public setGender() {
    this.selectedGender = this.genderList.find(
      c => c.label == this.form.sex
    )?.value
  }

  public async setInsurances() {
    const userInsurances = await getUserInsurances(this.form.rmT_UserId)
    this.selectedInsurances = this.insuranceList.filter(i =>
      userInsurances.some(ui => ui.insuranceID.toString() == i.value)
    )
    this.userInsurances = this.selectedInsurances.map(i => i.value).join(',')
  }
  public async fetchInsurances() {
    const response = await getInsurances(1, 1500)
    this.insuranceList = response.data.map(i => ({
      label: i.insuranceName,
      value: i.insuranceID.toString(),
      _isDisabled: false
    }))
  }
  public async fetchGenders() {
    const response = await getGenders()
    this.genderList.push(
      ...response.map(g => ({
        label: g.label,
        value: g.value.toString(),
        _isDisabled: false
      }))
    )
  }

  public selectAllInsurances() {
    const all = (this.insuranceList || []).map(i => ({ ...i }))
    this.selectedInsurances = []
    this.$nextTick(() => {
      this.selectedInsurances = all
    })
  }

  public onDOBContext(ctx) {
    this.formatted = moment(ctx).format('MM/DD/YYYY')
  }
  public onDOBInput(ctx) {
    const a = moment(ctx).toDate()
    if (a.toString() != 'Invalid Date') this.form.dob = a
  }

  public getLength(value) {
    return value ? value.toString().trim().length : 0
  }
}
